import { render, staticRenderFns } from "./globalmessage.vue?vue&type=template&id=5115acd5"
import script from "./globalmessage.vue?vue&type=script&lang=js"
export * from "./globalmessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports